export const gateway = 'https://villetta.payportal.org';
export const apikey = '7459c721-a4e0-462b-a672-e38a5177ecb9';
export const checkout = 'https://us-central1-akasha-sandbox.cloudfunctions.net/essentialsCheckout'; // Please update later
export const portal = {
  id: 7,
  path: 'tamil-audio-books',
  prefix: 'TAB',
  images: 'album',
  home: 'http://tamilaudiobooks.com',
  logo: {
    url: 'https://storage.googleapis.com/payportal-logo/tamilaudiobooks/large-logo.png',
    height: '100px',
    scroll: '20',
  },
  email_logo: 'https://storage.googleapis.com/payportal-logo/tamilaudiobooks/large-logo.png',
  name: 'Tamil Audio Books',
  ownerEmail: 'tamilaudiobooks@gmail.com',
  portal_account_address: {
    portal: 'Tamil Audio Books',
    street: 'Tamil Audio Books Store',
    city: 'Fremont',
    state: 'CA',
    postal_code: '94539',
    country: 'United States',
  },
  support_email: 'tamilaudiobooks@gmail.com',
  support_phone: '(925) 307 6734',
};
export const store = {
  description: "Audio books have been created and produced by Sri Srinivasa with all your blessings and good wishes.  Used intonations, voice modulations to bring out the life in the character as much and as closer to the manner in which the author has envisioned. Again, this is an attempt and please do provide your feedback). Would like to also thank Kalki's family for making Kalki's works available for generations to come.",
  note: 'Please, save this email with QR code or attached confirmation receipt. You will receive one-time download link(s) shortly from tamilaudiobooks@gmail.com.',
}